<template>
  <div class="g-footer flex-box">
    <div class="g-navs" :class="on('index') ?'c-on':''" @click="changeTab('/index')">
      <i class="iconfont icon-dangjian"></i>
      <p>首页</p>
    </div>
    <div class="g-navs" :class="on('informationIndex') ?'c-on':''" @click="changeTab('/informationIndex')">
      <i class="iconfont icon-zixun"></i>
      <p>资讯</p>
    </div>
    <div class="g-navs" :class="on('schoolAndCourse') ?'c-on':''" @click="changeTab('/schoolAndCourse')">
      <i class="iconfont icon-xuexiao"></i>
      <p>党校</p>
    </div>
    <div class="g-navs" :class="on('activityList') ?'c-on':''" @click="changeTab('/activityList')">
      <i class="iconfont icon-partycommittee"></i>
      <p>活动</p>
    </div>
    <div class="g-navs" :class="on('mine') ?'c-on':''" @click="changeTab('mine')">
      <i class="iconfont icon-dangwei"></i>
      <p>我的</p>
    </div>
    <!--<yd-popup class="g-confirm" v-model="showlogin" position="center" width="6.46rem" :close-on-masker="false">
      <div class="tit">提示</div>
      <p class="g-remindcont">该功能需登陆后才可使用，是否进行登录？</p>
      <div class="flex-box g-btnbox">
        <div class="btn g-bluebtn" @click="$router.push('/login')">登录</div>
        <div class="btn" @click="showlogin = false">再看看</div>
      </div>
    </yd-popup>-->
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import * as getData from '../service/getData'
  import * as mobile from '../config/mUtils'
  export default {
    props: ['navindex'],
    data () {
      return {
        index:'index',
        showlogin: false,
        parkToken: ''
      }
    },
    created () {
      this.index = this.navindex;
    },
    mounted () {
      this.parkToken = mobile.getStore('parkToken')
      this.parkToken = this.parkToken ? this.parkToken : this.$store.state.parkToken
    },
    computed: {
    },
    methods: {
      changeTab (path) {
        this.$router.push({path: path})
      },
      on (page) {
        return this.$route.path.indexOf(page) !== -1
      }
    },
    components: {
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-footer{
    position: relative;
    z-index: 9;
    @include wh(100%,1rem);
    background-color: #D60000;
    text-align: center;
    .g-navs{
      flex: 1;
      text-align: center;
      i{
        display: block;
        text-align: center;
        line-height: .5rem;
        @include sc(.5rem,#BCBCBC);
        margin-bottom: .05rem;
      }
      p{
        @include sc(.2rem,#BCBCBC);
        text-align: center;
        line-height: .26rem;
      }
    }
    .c-on{
      i,p{
        color: #fff;
      }
    }
  }

</style>




// WEBPACK FOOTER //
// footer.vue?15ec9a5c